import React, {useEffect, useState} from 'react';
import {Col, Container, Row} from 'reactstrap';
import {usePhaseState} from 'funnel-schedule/phase-context';
import {useUserState} from 'contexts/user';
import {subscribeToCampaign} from 'react-controlled-ab/datalayers/vwo';
import Section, {SectionImage} from 'components/Elements/Section';
import IconList, {IconListItem} from 'components/Elements/IconList';
import {faQuestionCircle} from '@fortawesome/pro-light-svg-icons';
import GuaranteeBox from 'components/Guarantee';
import {ImgCard} from 'components/Elements/ImgBullet';
import {ModuleAccordionV1} from 'components/ModuleAccordion';
import FaqList from 'components/FaqList';
import {RecipeTileBox} from 'components/Elements/Tile';
import {BonusOpen} from 'components/BonusList';
import ProductImage from 'components/Elements/ProductImage';
import {TestimonialBubble} from 'components/Testimonial';
import useBalanceText from 'utils/useBalanceText';
import {modulesAd, modulesPrevent, modulesOptimize, modulesReverse} from 'data/module.json';
import {faqAd} from 'data/faq.json';
import {SalesDisclaimer} from 'components/SalesCta';
import CheckoutButton from 'components/CheckoutButton';
import {acSpeakers} from 'data/ac18.json';
import {navItems} from 'data/salesNav.json';
import {Link, animateScroll as scroll} from 'react-scroll';
import CountdownTimer from 'components/Elements/CountdownTimer';

export default function SalesCopy({
  version = 'sales',
  variant = null,
  productId,
  productSku,
  productSlug,
  productPrice,
  paymentPlanPrice,
  salesFullPrice = false,
  ctaOverride = null,
  timerOverride = null,
  ctaNoTimer = false,
  ...props
}) {
  const {bucket, email} = useUserState();
  const {
    phases: {
      default: defaultSchedule = {
        phase: 'before'
      },
      webinar: webinarSchedule = {
        phase: 'before'
      }
    }
  } = usePhaseState();

  const bonusValue = '$500';

  const isCartClose = new Date(webinarSchedule.endOfSalesDay * 1000 - 86400000).getTime() < new Date().getTime();
  const salesEnd = new Date(webinarSchedule.endOfSalesDay * 1000).getTime();
  const salesTimerDate = timerOverride ? timerOverride : salesEnd;

  function SalesCtaSection({id, salesVersion = version, lastSection = false, ...props}) {
    return (
      <>
        <Section
          id={id}
          color="purple"
          className={lastSection ? 'section-angle-last' : ''}
          angle={lastSection ? 'none' : 'bottom'}
        >
          <Container>
            <Row>
              <Col>
                <h2 className="section-heading text-white text-center mb-0">
                  {
                    {screening: <>Today’s Special Early-Bird Enrollment Discount</>, sales: <>Ready Now? Join Us!</>}[
                      salesVersion
                    ]
                  }
                </h2>
                {
                  {
                    screening: (
                      <>
                        <h5 className="section-heading text-center text-400 text-white mt-3">
                          This early-bird discount is{' '}
                          <b>
                            <i>only for Masterclass attendees</i>
                          </b>{' '}
                          as a reward for investing an hour in this mission-critical aspect of your health.
                        </h5>
                        <h5 className="text-center text-white text-400 mt-0 mb-2">
                          *You can{' '}
                          <b>
                            <i>only</i>
                          </b>{' '}
                          unlock your special price on this page.*
                        </h5>
                        <p className="text-center text-white">(Do not hit refresh or close!) </p>
                      </>
                    ),
                    sales: <></>
                  }[version]
                }
                <div className="background-white rounded box-shadow-black-50 p-4 text-center mt-5">
                  {
                    {
                      screening: (
                        <>
                          <h2 className="text-center mt-4 mb-2">One-time offer:</h2>
                          <h3 className="text-center mt-0">Get a special 50% off discount.</h3>
                        </>
                      ),
                      sales: (
                        <>
                          <h3 className="mt-4 mb-2">Unlimited Access.</h3>
                          <h4 className="mt-0">Enjoy it all as much as you want.</h4>
                        </>
                      )
                    }[version]
                  }
                  <Row className="justify-content-center mb-4">
                    <Col lg="10">
                      <ProductImage />
                    </Col>
                  </Row>
                  {!salesFullPrice ? (
                    <h3 className="text-center text-400 mt-0 mb-3">
                      Regular Price: <del>$497</del>
                    </h3>
                  ) : null}
                  <h2 className="text-green mt-0">
                    Enroll TODAY for{' '}
                    {
                      {
                        screening: <>just $247 + Get the Action Collection for FREE!</>,
                        sales: <>{!salesFullPrice ? <>just $297</> : <>$497</>}</>
                      }[version]
                    }
                  </h2>
                  {
                    {
                      screening: (
                        <>
                          <h5 className="mt-0">
                            With this Special Masterclass Price, you save $250 by enrolling in <i>Tackling Type 2</i>{' '}
                            today.
                          </h5>
                        </>
                      ),
                      sales: (
                        <>
                          {!salesFullPrice ? (
                            <>
                              {ctaNoTimer ? null : (
                                <>
                                  <div className="cta-timer mb-3">
                                    <div className="offer-box-timer-text">Your discount expires in:</div>
                                    <CountdownTimer time={salesTimerDate} className="countdown-dark" />
                                  </div>
                                </>
                              )}
                            </>
                          ) : null}
                        </>
                      )
                    }[version]
                  }
                  <CheckoutButton
                    className="offer-box-button"
                    sku={productSku}
                    price={productPrice}
                    slug={productSlug}
                  />
                  <SalesDisclaimer />
                  <div className="offer-box-payment-plan mt-3">
                    Prefer a 3-month payment plan? We’ve got you covered!
                    <CheckoutButton
                      color="link"
                      className="btn-link-checkout ml-1"
                      sku={productSku}
                      price={paymentPlanPrice}
                      slug={productSlug}
                      queryParams={{opt: 1}}
                    >
                      Join now for just ${paymentPlanPrice}/month!
                    </CheckoutButton>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </Section>
      </>
    );
  }

  useBalanceText();
  return (
    <>
      {version === 'screening' ? <SalesCtaSection id="course-cta-screening" /> : null}

      <Section
        id="course-prevention"
        color={version === 'screening' ? 'black' : 'green'}
        type="bottom"
        className="text-center text-white"
      >
        <Container>
          <Row>
            <Col>
              {
                {
                  screening: (
                    <>
                      <h2 className="section-heading">The Masterclass was a smart first step.</h2>
                      <h3 className="m-0">
                        {
                          {
                            prevent: <>But what else do you need to know to prevent diabetes?</>,
                            optimize: <>But what else do you need to know to reverse prediabetes?</>,
                            reverse: <>But what else do you need to know to reverse diabetes?</>
                          }[bucket]
                        }
                      </h3>
                    </>
                  ),
                  sales: (
                    <>
                      {variant === 'ad' ? (
                        <>
                          <h2 className="section-heading">
                            There’s a problem on the horizon. (Maybe it runs in the family.)
                          </h2>
                          <h3 className="mt-0">
                            Conventional wisdom says it’s only going to get worse unless there’s a change.
                          </h3>
                          <h3 className="mt-0">But most of the solutions out there are outdated...</h3>
                        </>
                      ) : (
                        <>
                          <h2 className="section-heading">
                            {
                              {
                                prevent: <>The real reason it’s been so hard to prevent diabetes in the past:</>,
                                optimize: <>The real reason it’s been so hard to reverse prediabetes in the past:</>,
                                reverse: <>The real reason it’s been so hard to reverse diabetes in the past:</>
                              }[bucket]
                            }
                          </h2>
                          <h3 className="mt-0">The mainstream advice we’ve been handed is outdated.</h3>
                        </>
                      )}
                    </>
                  )
                }[version]
              }
            </Col>
          </Row>
        </Container>
      </Section>

      {
        {
          screening: (
            <>
              <SectionImage
                id="course-cut-carbs"
                color="light-gray"
                imgUrl={require('static/backgrounds/1352226526.jpg')}
              >
                <h3 className="section-heading">Does this sound familiar?</h3>
                {variant === 'ad' ? null : (
                  <p className="balance-text">
                    {
                      {
                        prevent: (
                          <>
                            There’s a problem on the horizon. And conventional wisdom says it’s only going to get worse
                            unless there’s a change.
                          </>
                        ),
                        optimize: (
                          <>
                            There’s a problem on the horizon. And conventional wisdom says it’s only going to get worse
                            unless there’s a change.
                          </>
                        ),
                        reverse: (
                          <>
                            There’s a problem. And conventional wisdom says it’s only going to get worse unless there’s
                            a change.
                          </>
                        )
                      }[bucket]
                    }
                  </p>
                )}
                <p className="balance-text">
                  {
                    {
                      prevent: <>They say you’re at risk. (Maybe it runs in the family.)</>,
                      optimize: <>They say you’re at risk. (Maybe it runs in the family.)</>,
                      reverse: <>They say you’re at risk.</>
                    }[bucket]
                  }
                </p>
                <p className="balance-text">They say, “cut out carbs and sugar!”</p>
                <p className="balance-text">They say, “lose weight!”</p>
                {
                  {
                    prevent: null,
                    optimize: null,
                    reverse: (
                      <p className="">
                        You are looking for lower A1C levels, better insulin sensitivity, improved blood glucose
                        control, and to show your health care practitioner that you’re headed in the right direction.
                      </p>
                    )
                  }[bucket]
                }
                <h5 className="mt-0">But it doesn’t feel that easy to do.</h5>
                <p className="text-balance">
                  Besides, how’s a person supposed to cut out carbs? It seems like they’re in everything — and aren’t
                  some of them good for us?
                </p>
                {
                  {
                    prevent: null,
                    optimize: null,
                    reverse: <p>You want to make a change in the way you eat and exercise.</p>
                  }[bucket]
                }
                <p className="text-balance">
                  {variant === 'ad' ? (
                    <>
                      Study after study shows that certain foods and something called “lifestyle” can make a difference.
                    </>
                  ) : (
                    <>
                      You’ve heard that studies show certain foods and something called “lifestyle” can make a
                      difference.
                    </>
                  )}
                </p>
                <p className="text-balance">
                  But what does that{' '}
                  <b>
                    <i>mean</i>
                  </b>{' '}
                  exactly?
                </p>
              </SectionImage>
            </>
          ),
          sales: null
        }[version]
      }

      <div className={version === 'sales' ? 'join-scroll-content' : 'screening-scroll-content'}>
        {version === 'sales' ? (
          <div className="course-nav d-none d-lg-block">
            <Container>
              <Row>
                <Col>
                  <div className="course-nav-list">
                    {navItems.map((link, i) => (
                      <Link
                        className="course-nav-list-item"
                        activeClass="active"
                        spy={true}
                        offset={-55}
                        to={link.slug}
                        smooth={true}
                        href="#"
                      >
                        {link.name}
                      </Link>
                    ))}
                  </div>
                </Col>
              </Row>
            </Container>
          </div>
        ) : null}

        <div id="course-why">
          <Section id="course-mind" color="white" type="both">
            <Container>
              <Row>
                <Col>
                  {variant === 'ad' ? null : (
                    <>
                      <h3 className="section-heading text-center">
                        {
                          {
                            prevent: <>In the back of your mind, you wonder if your routine is hurting you.</>,
                            optimize: <>In the back of your mind, you know that your routine is hurting you.</>,
                            reverse: <>In the back of your mind, you know that your routine is hurting you.</>
                          }[bucket]
                        }
                      </h3>
                      <h5 className="text-center text-400 mt-0 mb-5">
                        You know you could do a little bit better if only you knew the specifics like:
                      </h5>
                    </>
                  )}
                  <ImgCard
                    img={require('static/backgrounds/TT2-evergreen-page-screening-sales-eat-iStock-854725372.jpg')}
                    className="imgBulletCard-300 mb-5"
                  >
                    <h4 className="section-heading">What to eat.</h4>
                    <p className="text-h5">
                      {variant === 'ad' ? (
                        <>And how to switch out beloved pasta, which hurts in more ways than one.</>
                      ) : (
                        <>And how to wean yourself off pasta, which hurts you in more ways than one.</>
                      )}
                    </p>
                  </ImgCard>
                  <ImgCard
                    img={require('static/backgrounds/TT2-evergreen-page-screening-sales-when-iStock-667078838.jpg')}
                    className="imgBulletCard-300 mb-5"
                  >
                    <h4 className="section-heading">When to eat.</h4>
                    <p className="text-h5">
                      {variant === 'ad' ? (
                        <>Ever skip breakfast or eat late at night — how disruptive is this?</>
                      ) : (
                        <>
                          {
                            {
                              prevent: <>If you sometimes skip breakfast and eat late at night — does that matter?</>,
                              optimize: <>If you sometimes eat late at night — does that matter?</>,
                              reverse: <>If you sometimes skip breakfast and eat late at night — does that matter?</>
                            }[bucket]
                          }
                        </>
                      )}
                    </p>
                  </ImgCard>
                  <ImgCard
                    img={require('static/backgrounds/TT2-evergreen-page-screening-sales-move-iStock-1189130077.jpg')}
                    className="imgBulletCard-300 mb-5"
                  >
                    <h4 className="section-heading">When to move.</h4>
                    <p className="text-h5">
                      {variant === 'ad' ? (
                        <>
                          What are all the little details we need need to know, like how important it is to walk after a
                          meal to keep blood sugar levels healthy.
                        </>
                      ) : (
                        <>
                          What are all the little details you need to know, like how important it is to walk after a
                          meal to keep blood sugar in check?
                        </>
                      )}
                    </p>
                  </ImgCard>
                  <ImgCard
                    img={require('static/backgrounds/TT2-evergreen-page-screening-sales-weight-iStock-1331259098.jpg')}
                    className="imgBulletCard-300 mb-5"
                  >
                    <h4 className="section-heading">
                      {variant === 'ad' ? (
                        <>How to stay at a healthy weight. </>
                      ) : (
                        <>How to lose weight, and keep it from ever coming back.</>
                      )}
                    </h4>
                    <p className="text-h5">
                      {variant === 'ad' ? (
                        <>
                          Few people seem to pay attention to what they’re eating, and it seems daunting to find others
                          who want to let go of bad habits.
                        </>
                      ) : (
                        <>
                          Few people around you seem to pay attention to what they’re eating, and you’re wondering where
                          you can find support so you can let go of bad habits.
                        </>
                      )}
                    </p>
                    <p className="text-h5">
                      {variant === 'ad' ? (
                        <>
                          But it feels like a slog just to make it to the evening — and that’s when the cravings for
                          snacks and sweets really kick in.
                        </>
                      ) : (
                        <>
                          You’re willing to make a change but aren’t sure how because it feels like a slog just to make
                          it to the evening — and that’s when the cravings for snacks and sweets really kick in.
                        </>
                      )}
                    </p>
                  </ImgCard>
                </Col>
              </Row>
            </Container>
          </Section>

          {
            {
              screening: null,
              sales: (
                <>
                  <SectionImage
                    id="course-question"
                    color="light-gray"
                    imgPosition="right"
                    imgUrl={require('static/backgrounds/1212263337.jpg')}
                  >
                    <h3 className="section-heading">
                      {variant === 'ad' ? (
                        <>Each meal feels like a giant question mark, but it’s become too hard to ignore.</>
                      ) : (
                        <>Each meal feels like a giant question mark, and you can’t ignore it anymore.</>
                      )}
                    </h3>
                    <p>In fact, there are so many question marks…</p>
                    <IconList iconColor="purple">
                      <IconListItem icon={faQuestionCircle}>“Is this food going to harm me?”</IconListItem>
                      <IconListItem icon={faQuestionCircle}>
                        “Am I going to get saddled with medications for the rest of my life?”
                      </IconListItem>
                      <IconListItem icon={faQuestionCircle}>
                        {variant === 'ad' ? (
                          <>
                            “I know weight is a major risk factor, but diets and exercise haven’t worked in the past.
                            What REALLY works?
                          </>
                        ) : (
                          <>
                            “I know extra weight is a major risk factor, but diets and exercise haven’t worked in the
                            past. What REALLY works to lose weight and keep it off?”
                          </>
                        )}
                      </IconListItem>
                      <IconListItem icon={faQuestionCircle}>
                        “How can I ditch the sweets and coffee that get me through the day?”
                      </IconListItem>
                      <IconListItem icon={faQuestionCircle}>
                        “How do I get motivated to exercise more, especially when I’m so tired?”
                      </IconListItem>
                      <IconListItem icon={faQuestionCircle}>“What else am I missing?”</IconListItem>
                    </IconList>
                  </SectionImage>

                  <SectionImage id="course-avoid" color="white" imgUrl={require('static/backgrounds/949781856.jpg')}>
                    <Container>
                      <Row>
                        <Col>
                          <h3 className="section-heading">
                            {variant === 'ad' ? (
                              <>
                                Most people get very little instruction on what to eat and do for diabetes besides
                                blanket advice to “Avoid sugar.”
                              </>
                            ) : (
                              <>
                                Most people get very little instruction on what to eat and do to prevent diabetes
                                besides blanket advice to “Avoid sugar.”
                              </>
                            )}
                          </h3>
                          <p>
                            {variant === 'ad' ? (
                              <>That alone won’t keep us from sliding into the danger zone.</>
                            ) : (
                              <>That alone won’t keep you from sliding into the danger zone.</>
                            )}
                          </p>
                          <p>Why? It’s outdated advice.</p>
                          <p>
                            {variant === 'ad' ? (
                              <>The conventional wisdom says to eat less sugar and simple carbs.</>
                            ) : (
                              <>
                                The conventional wisdom says to eat less sugar and simple carbs to avoid glucose spikes.
                              </>
                            )}
                          </p>
                          <p>But a healthy body can eat carbohydrates, fruit, and even a little table sugar.</p>
                          <p>
                            In fact, we all need sugar and carbs for energy. That’s why athletes love eating these
                            things before a big race.
                          </p>
                        </Col>
                      </Row>
                    </Container>
                  </SectionImage>

                  <SectionImage
                    id="course-root"
                    color="light-gray"
                    imgUrl={require('static/backgrounds/1152156138.jpg')}
                    imgPosition="right"
                  >
                    <h3 className="section-heading">
                      Eliminating all sugar and carbs doesn’t get to the root of the problem.
                    </h3>
                    <p>
                      Many people try this and end up eating more foods (like saturated fats{' '}
                      <br className="d-none d-xl-block" />
                      or processed foods) that cause the problem to get worse.
                    </p>
                    <p>The new way of understanding type 2 diabetes makes much more sense.</p>
                    <p>It’s not a sugar problem.</p>
                    <p>It’s a problem with the way the body stores fat.</p>
                    <p>
                      {variant === 'ad' ? (
                        <>
                          That’s why there’s such a big connection between <br className="d-none d-xl-block" />
                          weight and diabetes. (Ever hear the term “diabesity”?)
                        </>
                      ) : (
                        <>
                          That’s why there’s such a big connection between <br className="d-none d-xl-block" />
                          extra weight and diabetes. (Ever hear the term “diabesity”?)
                        </>
                      )}
                    </p>
                    <h5 className="mt-0">
                      {variant === 'ad' ? (
                        <>We’ve discovered what’s at the root.</>
                      ) : (
                        <>We’ve discovered what to do to fix this problem — at the root.</>
                      )}
                    </h5>
                  </SectionImage>

                  <SectionImage
                    id="course-breakthrough"
                    color="white"
                    imgPosition="left"
                    imgUrl={require('static/backgrounds/1298149992.jpg')}
                  >
                    <h3 className="section-heading">
                      This breakthrough is so new, very few professionals know about it.
                    </h3>
                    <p>Internet articles don’t mention it.</p>
                    <p>Not many books on the subject exist.</p>
                    <p>
                      {variant === 'ad' ? (
                        <>
                          And none of these give guidance on{' '}
                          <b>
                            how to <i>actually</i> make new healthy habits stick
                          </b>{' '}
                          — it’s hard to get motivated when we’re tired all the time!
                        </>
                      ) : (
                        <>
                          And none of these give you guidance on{' '}
                          <b>
                            how to <i>actually</i> make new healthy habits stick
                          </b>{' '}
                          — it’s hard to get motivated when you’re tired all the time!
                        </>
                      )}
                    </p>
                    <h3 className="mt-4 mb-0">But that’s all about to change.</h3>
                  </SectionImage>

                  {variant === 'ad' ? null : (
                    <SectionImage
                      id="course-imagine"
                      color="light-gray"
                      imgPosition="right"
                      imgUrl={require('static/backgrounds/TT2-evergreen-page-screening-sales-change-iStock-1325578537.jpg')}
                    >
                      <p>
                        {
                          {
                            prevent: (
                              <>
                                Imagine how good it will feel to say, “I know exactly what to do to keep my blood sugars
                                stable and prevent diabetes.”
                              </>
                            ),
                            optimize: (
                              <>
                                Imagine how good it will feel to say, “I know exactly what to do to keep my blood sugars
                                stable and to kick prediabetes to the curb.”
                              </>
                            ),
                            reverse: (
                              <>
                                Imagine how good it will feel to say, “I know exactly what to do to keep my blood sugars
                                stable and to kick diabetes.”
                              </>
                            )
                          }[bucket]
                        }
                      </p>
                      <p>
                        {
                          {
                            prevent: <>To avoid a diagnosis and all the fatigue, pain, expense, and frustration.</>,
                            optimize: (
                              <>Or going to your doctor and they say, “Whatever you’re doing, keep doing it!”</>
                            ),
                            reverse: <>Or going to your doctor and they say, “Whatever you’re doing, keep doing it!”</>
                          }[bucket]
                        }
                      </p>
                      {
                        {
                          prevent: null,
                          optimize: null,
                          reverse: (
                            <p>
                              To move towards lower A1C, better insulin sensitivity, improved blood glucose control, a
                              healthy body weight, and regular daily physical activity.
                            </p>
                          )
                        }[bucket]
                      }
                      <p>
                        We’ll show you how to stick with the changes long-term so you can add precious life to your
                        years, and enjoy all of the special moments fully and freely.
                      </p>
                    </SectionImage>
                  )}

                  <SectionImage
                    id="course-change"
                    color={variant === 'ad' ? 'light-gray' : 'white'}
                    imgUrl={require('static/backgrounds/TT2-evergreen-page-screening-sales-everest-iStock-1199648281.jpg')}
                    imgPosition="left"
                  >
                    <h3 className="section-heading">Making a change doesn’t have to feel like climbing Mt. Everest.</h3>
                    <p>In fact, it doesn’t have to be painful at all.</p>
                    <p>
                      {variant === 'ad' ? (
                        <>It’s not necessary to change everything overnight.</>
                      ) : (
                        <>You don’t need to change your whole life overnight.</>
                      )}
                    </p>
                    <p>
                      {variant === 'ad' ? (
                        <>
                          We don’t need to spend our entire weekend figuring out what to eat for the rest of the week.
                          (No one has time for that!)
                        </>
                      ) : (
                        <>
                          And you don’t need to spend your entire weekend figuring out what to eat for the rest of the
                          week. (No one has time for that!)
                        </>
                      )}
                    </p>
                  </SectionImage>
                </>
              )
            }[version]
          }

          <Section id="course-worry" color="black" className="text-white">
            <Container>
              <Row className="text-center">
                <Col>
                  {variant === 'ad' ? null : (
                    <h2 className="section-heading">
                      {
                        {
                          prevent: <>Go from worried about what might happen if you get diabetes…</>,
                          optimize: <>Go from worried about what might happen if you get diabetes…</>,
                          reverse: <>Go from worried about what might happen if things get worse…</>
                        }[bucket]
                      }
                    </h2>
                  )}
                  {variant === 'ad' ? null : (
                    <h2 className="section-heading">
                      {
                        {
                          prevent: (
                            <>
                              To knowing <i>exactly</i> what to do to avoid a diagnosis — and doing it.
                            </>
                          ),
                          optimize: (
                            <>
                              To knowing <i>exactly</i> what to do to reverse prediabetes — and doing it.
                            </>
                          ),
                          reverse: (
                            <>
                              To knowing <i>exactly</i> what to do to reverse type 2 diabetes — and doing it.
                            </>
                          )
                        }[bucket]
                      }
                    </h2>
                  )}
                  {variant === 'ad' ? (
                    <>
                      <h2 className="section-heading">Ready for a proven roadmap?</h2>
                      <p>
                        It’s time to get guidance from an expert who’s helped thousands of people take their health
                        back.
                      </p>
                    </>
                  ) : (
                    <>
                      <h4 className="mt-0">Are you ready for a proven roadmap?</h4>
                      <p>
                        {
                          {
                            prevent: (
                              <>
                                It’s time to get guidance from an expert who’s helped thousands of people prevent
                                diabetes.
                              </>
                            ),
                            optimize: (
                              <>
                                It’s time to get guidance from an expert who’s helped thousands of people reverse
                                prediabetes.
                              </>
                            ),
                            reverse: (
                              <>
                                It’s time to get guidance from an expert who’s helped thousands of people reverse
                                diabetes.
                              </>
                            )
                          }[bucket]
                        }
                      </p>
                      <p>
                        {
                          {
                            prevent: (
                              <>
                                And the best part is, you won’t just be keeping diabetes out of your life — you’ll be
                                doing <br className="d-none d-xl-block" />
                                exactly what you need to boost energy, lose weight, and feel younger overall.
                              </>
                            ),
                            optimize: (
                              <>
                                And the best part is, you won’t just be keeping diabetes out of your life — you’ll be
                                doing <br className="d-none d-xl-block" />
                                exactly what you need to boost energy, lose weight, and feel younger overall.
                              </>
                            ),
                            reverse: (
                              <>
                                And the best part is, you won’t just be defeating diabetes — you’ll be doing{' '}
                                <br className="d-none d-xl-block" />
                                exactly what you need to boost energy, lose weight, and feel younger overall.
                              </>
                            )
                          }[bucket]
                        }
                      </p>
                    </>
                  )}
                </Col>
              </Row>
            </Container>
          </Section>

          <Section id="course-intro" color="white">
            <Container>
              <Row className="text-center mb-5">
                <Col>
                  <p>
                    <i>Introducing...</i>
                  </p>
                  <img
                    className="img-course-logo-tt2 mb-4"
                    src="https://cdn.foodrevolution.org/tt2/tt2-logo-2024.svg"
                  />
                  <p className="balance-text">
                    {variant === 'ad' ? (
                      <>
                        A step-by-step online program to keep blood sugar healthy, gain energy, and live your healthiest
                        life — naturally.
                      </>
                    ) : (
                      <>
                        {
                          {
                            prevent: (
                              <>
                                A step-by-step online program to prevent diabetes, gain energy, and live your absolute
                                healthiest life — naturally.
                              </>
                            ),
                            optimize: (
                              <>
                                A step-by-step online program to reverse prediabetes, gain energy, and live your
                                absolute healthiest life — naturally.
                              </>
                            ),
                            reverse: (
                              <>
                                A step-by-step online program to reverse type 2 diabetes, gain energy, and live your
                                absolute healthiest life — naturally.
                              </>
                            )
                          }[bucket]
                        }
                      </>
                    )}
                  </p>
                </Col>
              </Row>
              <Row>
                <Col>
                  {variant === 'ad' ? (
                    <>
                      <ImgCard
                        img={require('static/backgrounds/TT2-evergreen-page-screening-sales-learn-iStock-640107874.jpg')}
                        className="imgBulletCard-300 mb-4 text-h5"
                      >
                        <b>Learn which foods to eat</b> including all the major dos and don’ts for an outstanding
                        quality of life
                      </ImgCard>
                      <ImgCard
                        img={require('static/backgrounds/TT2-evergreen-page-screening-sales-plan-iStock-1352225167.jpg')}
                        className="imgBulletCard-300 mb-4 text-h5"
                      >
                        <b>Hear what really works to stay at a healthy weight</b>
                      </ImgCard>
                      <ImgCard
                        img={require('static/backgrounds/TT2-evergreen-page-screening-sales-support-iStock-1280247430.jpg')}
                        className="imgBulletCard-300 mb-4 text-h5"
                      >
                        <b>Get support and guidance</b> to put healthy habits into place (and keep them!)
                      </ImgCard>
                      <ImgCard
                        img={require('static/backgrounds/864430134-wide.jpg')}
                        className="imgBulletCard-300 mb-4 text-h5"
                      >
                        <b>Eliminate the learning curve</b> and get to the root cause
                      </ImgCard>
                      <ImgCard
                        img={require('static/backgrounds/TT2-evergreen-page-screening-sales-end-iStock-871227828.jpg')}
                        className="imgBulletCard-300 mb-4 text-h5"
                      >
                        <b>End confusion</b> when it comes to nutrients, deficiencies, and how food impacts blood sugar,
                        insulin, and energy levels
                      </ImgCard>
                      <ImgCard
                        img={require('static/backgrounds/1396929791-wide.jpg')}
                        className="imgBulletCard-300 mb-4 text-h5"
                      >
                        <b>Follow a proven plan</b> to move more and slash risk, even if it runs in the family
                      </ImgCard>
                      <ImgCard
                        img={require('static/backgrounds/TT2-evergreen-page-screening-sales-tips-iStock-1313903358.jpg')}
                        className="imgBulletCard-300 mb-4 text-h5"
                      >
                        <b>Learn simple tips</b> to prepare simple, healthy, and delicious meals for maximum energy
                      </ImgCard>
                    </>
                  ) : (
                    <>
                      {
                        {
                          prevent: (
                            <>
                              <ImgCard
                                img={require('static/backgrounds/TT2-evergreen-page-screening-sales-learn-iStock-640107874.jpg')}
                                className="imgBulletCard-300 mb-4 text-h5"
                              >
                                <b>Learn which foods to eat</b> including all the major dos and don’ts to keep blood
                                sugar stable
                              </ImgCard>
                              <ImgCard
                                img={require('static/backgrounds/TT2-evergreen-page-screening-sales-plan-iStock-1352225167.jpg')}
                                className="imgBulletCard-300 mb-4 text-h5"
                              >
                                <b>Follow a proven plan to lose weight (if that’s your goal),</b> move more, and slash
                                the risk of developing diabetes, even if it runs in the family
                              </ImgCard>
                              <ImgCard
                                img={require('static/backgrounds/TT2-evergreen-page-screening-sales-support-iStock-1280247430.jpg')}
                                className="imgBulletCard-300 mb-4 text-h5"
                              >
                                <b>Get support and guidance</b> to put healthy habits into place
                              </ImgCard>
                              <ImgCard
                                img={require('static/backgrounds/TT2-evergreen-page-screening-sales-discover-iStock-1221739066.jpg')}
                                className="imgBulletCard-300 mb-4 text-h5"
                              >
                                <b>Discover how diet and lifestyle affect blood glucose,</b> insulin resistance,
                                prediabetes, and type 2 diabetes
                              </ImgCard>
                              <ImgCard
                                img={require('static/backgrounds/TT2-evergreen-page-screening-sales-tips-iStock-1313903358.jpg')}
                                className="imgBulletCard-300 mb-4 text-h5"
                              >
                                <b>Learn simple tips to prepare simple and delicious meals</b> for maximum energy and
                                healthy blood sugar balance
                              </ImgCard>
                              <ImgCard
                                img={require('static/backgrounds/TT2-evergreen-page-screening-sales-end-iStock-871227828.jpg')}
                                className="imgBulletCard-300 mb-4 text-h5"
                              >
                                <b>End confusion</b> when it comes to important nutrients you could be missing
                              </ImgCard>
                            </>
                          ),
                          optimize: (
                            <>
                              <ImgCard
                                img={require('static/backgrounds/TT2-evergreen-page-screening-sales-learn-iStock-640107874.jpg')}
                                className="imgBulletCard-300 mb-4 text-h5"
                              >
                                <b>Learn which foods to eat</b> including all the major dos and don’ts to keep blood
                                sugar stable
                              </ImgCard>
                              <ImgCard
                                img={require('static/backgrounds/TT2-evergreen-page-screening-sales-plan-iStock-1352225167.jpg')}
                                className="imgBulletCard-300 mb-4 text-h5"
                              >
                                <b>Follow a proven plan to lose weight (if that’s your goal),</b> move more, and slash
                                the risk of developing diabetes, even if it runs in the family
                              </ImgCard>
                              <ImgCard
                                img={require('static/backgrounds/864430134-wide.jpg')}
                                className="imgBulletCard-300 mb-4 text-h5"
                              >
                                <b>Eliminate the learning curve</b> and do more than just treat the symptoms — get to
                                the root cause
                              </ImgCard>
                              <ImgCard
                                img={require('static/backgrounds/TT2-evergreen-page-screening-sales-support-iStock-1280247430.jpg')}
                                className="imgBulletCard-300 mb-4 text-h5"
                              >
                                <b>Get support and guidance to put healthy habits into place</b> so you don’t develop
                                type 2 diabetes
                              </ImgCard>
                              <ImgCard
                                img={require('static/backgrounds/TT2-evergreen-page-screening-sales-discover-iStock-1221739066.jpg')}
                                className="imgBulletCard-300 mb-4 text-h5"
                              >
                                <b>Discover how diet and lifestyle affect blood glucose,</b> insulin resistance,
                                prediabetes, and type 2 diabetes
                              </ImgCard>
                              <ImgCard
                                img={require('static/backgrounds/TT2-evergreen-page-screening-sales-tips-iStock-1313903358.jpg')}
                                className="imgBulletCard-300 mb-4 text-h5"
                              >
                                <b>Learn simple tips to prepare simple and delicious meals</b> for maximum energy and
                                healthy blood sugar balance
                              </ImgCard>
                              <ImgCard
                                img={require('static/backgrounds/TT2-evergreen-page-screening-sales-end-iStock-871227828.jpg')}
                                className="imgBulletCard-300 mb-4 text-h5"
                              >
                                <b>End confusion</b> when it comes to important nutrients you could be missing
                              </ImgCard>
                            </>
                          ),
                          reverse: (
                            <>
                              <ImgCard
                                img={require('static/backgrounds/TT2-evergreen-page-screening-sales-learn-iStock-640107874.jpg')}
                                className="imgBulletCard-300 mb-4 text-h5"
                              >
                                <b>Learn which foods to eat</b> including all the major dos and don’ts to feel better
                                immediately
                              </ImgCard>
                              <ImgCard
                                img={require('static/backgrounds/TT2-evergreen-page-screening-sales-plan-iStock-1352225167.jpg')}
                                className="imgBulletCard-300 mb-4 text-h5"
                              >
                                <b>Follow a proven plan to lose weight (if that’s your goal),</b> move more, and slash
                                the risk of type 2 diabetes complications, even if you haven’t been active lately
                              </ImgCard>
                              <ImgCard
                                img={require('static/backgrounds/864430134-wide.jpg')}
                                className="imgBulletCard-300 mb-4 text-h5"
                              >
                                <b>Eliminate the learning curve</b> and do more than just treat the symptoms with
                                medications — get to the root cause
                              </ImgCard>
                              <ImgCard
                                img={require('static/backgrounds/TT2-evergreen-page-screening-sales-tips-iStock-1313903358.jpg')}
                                className="imgBulletCard-300 mb-4 text-h5"
                              >
                                <b>Learn exactly what to do to keep blood sugars stable</b> and potentially put type 2
                                diabetes into remission
                              </ImgCard>
                              <ImgCard
                                img={require('static/backgrounds/TT2-evergreen-page-screening-sales-discover-iStock-1221739066.jpg')}
                                className="imgBulletCard-300 mb-4 text-h5"
                              >
                                <b>Discover how diet and lifestyle affect blood glucose,</b> insulin resistance,
                                prediabetes, and type 2 diabetes
                              </ImgCard>
                              <ImgCard
                                img={require('static/backgrounds/TT2-evergreen-page-screening-sales-end-iStock-871227828.jpg')}
                                className="imgBulletCard-300 mb-4 text-h5"
                              >
                                <b>End confusion</b> when it comes to important nutrients you could be missing
                              </ImgCard>
                            </>
                          )
                        }[bucket]
                      }
                    </>
                  )}
                </Col>
              </Row>
              <Row>
                <Col>
                  <h5 className="text-center mb-0">
                    All taught by Brenda Davis, award-winning Registered Dietitian and bestselling author of books
                    including <i>Kick Diabetes</i> and <i>Defeating Diabetes.</i> Hosted by Ocean Robbins of Food
                    Revolution Network.
                  </h5>
                </Col>
              </Row>
            </Container>
          </Section>

          <Section id="course-praise" color="light-gray">
            <Container>
              <Row>
                <Col>
                  <h3 className="section-heading text-center mb-3">Praise for Diabetes Expert Brenda Davis</h3>
                  <p className="text-center text-small mb-5">
                    <i>
                      These testimonials reflect people’s unique experience with Brenda’s work. Your specific experience
                      will vary.
                    </i>
                  </p>
                  <TestimonialBubble id="tt2-vesanto-m" bgColor="white" className="mb-5" />
                  <TestimonialBubble id="tt2-judy" bgColor="white" className="mb-5" />
                  <TestimonialBubble id="tt2-mirta-g" bgColor="white" className={variant === 'ad' ? '' : 'mb-5'} />
                  {variant === 'ad' ? null : <TestimonialBubble id="tt2-andres" bgColor="white" />}
                </Col>
              </Row>
            </Container>
          </Section>

          <SalesCtaSection id="course-cta-1" />
        </div>

        <div id="course-includes">
          <Section id="course-includes-1" color="green" className="text-center text-white">
            <Container>
              <Row>
                <Col>
                  <h2 className="section-only-heading">Tackling Type 2 Includes</h2>
                </Col>
              </Row>
            </Container>
          </Section>

          <Section id="course-includes-2" color="white">
            <Container>
              <Row>
                <Col>
                  <h2 className="section-heading text-center mb-0">6 modules, each with 6 engaging video lessons</h2>
                </Col>
              </Row>
              <Row className="justify-content-center text-center">
                <Col lg="10" xl="8">
                  <img
                    className="my-4"
                    src="https://cdn.foodrevolution.org/tt2/TT2-Product-Image-Tablet-phone-202402.png"
                    style={{maxHeight: '350px'}}
                  />
                </Col>
              </Row>
              <Row className="justify-content-center">
                <Col lg="10">
                  <p>
                    {variant === 'ad' ? (
                      <>
                        Nobody is born knowing how to live a diabetes-free life. But thankfully, we now know the proven
                        steps that can make a huge impact.
                      </>
                    ) : (
                      <>
                        The instant you join, you’ll be able to dive into the video trainings where you’ll find complete
                        instructions to help you live a diabetes-free life.
                      </>
                    )}
                  </p>
                  <p>
                    {variant === 'ad' ? (
                      <>
                        Join Brenda Davis, RD, and Ocean Robbins as they go through the ins and outs of nutrition,
                        optimal weight, exercise, sleep best practices, and more — providing the complete education that
                        most people never get.
                      </>
                    ) : (
                      <>
                        Join Brenda Davis, RD, and Ocean Robbins as they guide you through the ins and outs of
                        nutrition, exercise, optimal sleep practices, lasting weight loss, and more — giving you a
                        complete education in diabetes prevention and reversal.
                      </>
                    )}
                  </p>
                  <p>
                    {variant === 'ad' ? (
                      <>
                        All lessons are available in HD video, MP3 audio, and with downloadable transcripts for those
                        who prefer to read.
                      </>
                    ) : (
                      <>
                        All lessons are available in HD video, MP3 audio, and with downloadable transcripts, if you
                        prefer to read.
                      </>
                    )}
                  </p>
                </Col>
              </Row>
            </Container>
          </Section>

          <Section id="course-includes-3" color="light-gray">
            <Container>
              <Row>
                <Col>
                  <h2 className="section-heading text-center">
                    36 easy plant-based recipes, with gluten-free and soy-free options
                  </h2>
                </Col>
              </Row>
              <Row className="justify-content-center">
                <Col lg="10">
                  {variant === 'ad' ? (
                    <>
                      <p>
                        Meet the delicious, crowd-pleasing meals that scream anything but “special diet.” It’s easy to
                        adopt new habits when it’s all clearly laid out with tasty meals that come together in minutes.
                      </p>
                      <p>
                        Each of these no-fuss recipes is designed to pair flavor with function, offering
                        nutritionist-approved meals that nourish the body and soul with each bite.
                      </p>
                    </>
                  ) : (
                    <p>
                      You never feel like you’re on a “special diet” with these crowd-pleasing meals. The last thing we
                      want is to feed ourselves or our loved ones meals that make us sick. That’s why each of these
                      no-fuss recipes is designed to pair flavor with function, so you get nutritionist-approved meals
                      that nourish your body and soul with each bite.
                    </p>
                  )}
                  <p>
                    {variant === 'ad' ? (
                      <>Get ready to find new favorite dishes, for the whole family to enjoy without worry or guilt!</>
                    ) : (
                      <>
                        Get ready to find your new favorite dish, for you and the whole family to enjoy without worry or
                        guilt!
                      </>
                    )}
                  </p>
                </Col>
              </Row>
              <Row className="mt-4">
                <Col lg="6" className="mb-4">
                  <RecipeTileBox id="zesty-black-bean-soup" />
                </Col>
                <Col lg="6" className="mb-4">
                  <RecipeTileBox id="baked-apple-spice-oatmeal" />
                </Col>
                <Col lg="6" className="mb-4">
                  <RecipeTileBox id="hearty-split-pea-lentil-and-barley-soup" />
                </Col>
                <Col lg="6" className="mb-4">
                  <RecipeTileBox id="asparagus-risotto" />
                </Col>
                <Col lg="6" className="mb-4 mb-lg-0">
                  <RecipeTileBox id="turmeric-tea-elixer" />
                </Col>
                <Col lg="6" className="mb-0">
                  <RecipeTileBox id="chia-berry-bowl" />
                </Col>
              </Row>
            </Container>
          </Section>

          <Section id="course-includes-4" color="white">
            <Container>
              <Row>
                <Col>
                  <h2 className="section-heading text-center mb-0">
                    Health Coaches and Certified Nutritionists to answer your questions
                  </h2>
                </Col>
              </Row>
              <Row className="justify-content-center text-center">
                <Col lg="10" xl="8">
                  <img
                    className="my-4"
                    src={require('static/course-details-coaches.png')}
                    style={{maxHeight: '350px'}}
                  />
                </Col>
              </Row>
              <Row className="justify-content-center">
                <Col lg="10">
                  {variant === 'ad' ? (
                    <p>
                      This isn’t a course that presents the modules and leaves you hanging with all those questions.
                    </p>
                  ) : null}
                  <p>
                    {variant === 'ad' ? (
                      <>We’ve designed an interactive experience where our team is ready and available for guidance.</>
                    ) : (
                      <>
                        We’ve designed an interactive experience where you can chat with our team and get support where
                        you need it most.
                      </>
                    )}
                  </p>
                  <p>
                    {variant === 'ad' ? (
                      <>
                        Come back anytime to get pressing health, food, and diabetes questions answered, even after all
                        the modules are completed.
                      </>
                    ) : (
                      <>
                        Come back anytime to ask your health, food, and diabetes questions, even after you’ve completed
                        all the modules. You’ll always have a place to get help finding answers.
                      </>
                    )}
                  </p>
                  <p>
                    {variant === 'ad' ? (
                      <>
                        This rare level of support can make all the difference when it comes to getting unstuck and
                        making huge strides.
                      </>
                    ) : (
                      <>
                        This rare level of support can make all the difference when it comes to getting unstuck and
                        making huge strides towards your goals.
                      </>
                    )}
                  </p>
                </Col>
              </Row>
            </Container>
          </Section>

          <SectionImage id="course-includes-5" color="light-gray" imgUrl={require('static/backgrounds/1188864563.jpg')}>
            <h2 className="section-heading">Access to an exclusive community forum</h2>
            <p>
              {variant === 'ad' ? (
                <>
                  Temptation is everywhere — making it a lonely road without the right support. That’s why Tackling Type
                  2 offers instant membership to a lively community to connect with others who share the same common
                  goal: to get and stay healthy.
                </>
              ) : (
                <>
                  Temptation is everywhere, making it a lonely road — unless you have the right support. That’s why
                  Tackling Type 2 gives you instant membership to a lively community where you can connect with others
                  who share the same goal as you: to get and stay healthy.
                </>
              )}
            </p>
            <p>
              {variant === 'ad' ? (
                <>
                  Post questions, swap recipes, share struggles and celebrate all of the many wins. This forum is
                  customized for course participants — and it’s not on Facebook.
                </>
              ) : (
                <>
                  Post questions, swap recipes, share struggles and celebrate your many wins. This forum is customized
                  for course participants — and it’s not on Facebook.
                </>
              )}
            </p>
          </SectionImage>

          <Section id="course-includes-6" color="white">
            <Container>
              <Row>
                <Col>
                  <h2 className="section-heading text-center mb-0">Downloadable Coursebook</h2>
                </Col>
              </Row>
              <Row className="justify-content-center text-center">
                <Col lg="10" xl="8">
                  <img
                    className="my-4"
                    src="https://cdn.foodrevolution.org/tt2/tt2-coursebook-202402.png"
                    style={{maxHeight: '350px'}}
                  />
                </Col>
              </Row>
              <Row className="justify-content-center">
                <Col lg="10">
                  <p>
                    {variant === 'ad' ? (
                      <>
                        We’ve designed the ultimate coursebook to help participants master the lessons and track
                        celebration-worthy progress.
                      </>
                    ) : (
                      <>
                        We’ve designed the ultimate coursebook to help you remember what you learn and track how far
                        you’ve come in such a short time.
                      </>
                    )}
                  </p>
                  <p>
                    {variant === 'ad' ? (
                      <>
                        Over and over, our students tell us this is the #1 way to get the most out of each module. It
                        offers a simple way to follow along with the course and retain knowledge for healthy habits that
                        last a lifetime.
                      </>
                    ) : (
                      <>
                        Over and over, our students tell us this is the #1 way to get the most out of each module.
                        You’ll be able to follow along with the lessons, take notes, and retain what you learn so you
                        can make new healthy habits that last a lifetime.
                      </>
                    )}
                  </p>
                  <p>
                    {variant === 'ad' ? (
                      <>It’s easy to make the best choices when we have a way to truly absorb what we learn.</>
                    ) : (
                      <>Before long, you’ll be making better choices, automatically.</>
                    )}
                  </p>
                </Col>
              </Row>
            </Container>
          </Section>

          <Section id="course-includes-7" color="light-gray">
            <Container>
              <Row>
                <Col>
                  <h2 className="section-heading text-center mb-0">
                    6 recipe demonstration lessons showing exactly how to prepare meals
                  </h2>
                </Col>
              </Row>
              <Row className="justify-content-center text-center">
                <Col lg="10" xl="8">
                  <img className="my-4" src={require('static/cooking-demo.jpg')} style={{maxHeight: '350px'}} />
                </Col>
              </Row>
              <Row className="justify-content-center">
                <Col lg="10">
                  {variant === 'ad' ? (
                    <>
                      <p>
                        Healthy ingredients on the menu? Check. Healing food on the counter? Yes! But are they being
                        prepared so that vital nutrients aren’t lost in the cooking process?
                      </p>
                      <p>
                        It’s not enough just to throw ingredients together, which is why it’s helpful to watch someone
                        else do it first. Not only do these tips save time in the kitchen, these lessons are perfect for
                        making new healthy habits stick.
                      </p>
                    </>
                  ) : (
                    <>
                      <p>
                        You have the ingredients. You’re ready to make a healthy meal. But are you cooking in the best
                        way so you don’t accidentally lose nutrients, and so your body can absorb the good foods you
                        prepare?
                      </p>
                      <p>
                        Thanks to the recipe cooking demos, not only will you make sure you aren’t making any common
                        mistakes, you’ll learn techniques to save time in the kitchen.
                      </p>
                      <p>
                        If you’re looking to get inspired, reignite your love for cooking, and lose any excess weight,
                        you’ll love these lessons.
                      </p>
                    </>
                  )}
                </Col>
              </Row>
            </Container>
          </Section>

          <Section id="course-includes-8" color="white">
            <Container>
              <Row>
                <Col>
                  <h2 className="section-heading text-center mb-0">Q&A with Brenda Davis, RD</h2>
                </Col>
              </Row>
              <Row className="justify-content-center text-center">
                <Col lg="10" xl="8">
                  <img
                    className="my-4"
                    src="https://cdn.foodrevolution.org/tt2/tt2-qa-slide-202402.jpg"
                    style={{maxHeight: '350px'}}
                  />
                </Col>
              </Row>
              <Row className="justify-content-center">
                <Col lg="10">
                  <p>
                    {variant === 'ad' ? (
                      <>
                        Kick things off with a seismic shift in the understanding of all things diabetes. Brenda takes
                        the TOP questions from our community and breaks them all down with easy-to-understand
                        explanations. Get ready for aha moments galore. One of Brenda’s true gifts is explaining things
                        in a way that not only reveals lifesaving information but inspires healthy habit changes.
                      </>
                    ) : (
                      <>
                        Kick things off with a seismic shift in your understanding of all things diabetes. Brenda takes
                        the TOP questions from our community and breaks them all down with easy-to-understand
                        explanations. One of Brenda’s true gifts is explaining things in a way that not only reveals
                        lifesaving information but inspires healthy habit changes.
                      </>
                    )}
                  </p>
                  <p>
                    {variant === 'ad' ? (
                      <>
                        Don’t miss this incredible opportunity to get pressing health questions answered by one of the
                        best nutritionists in the world.
                      </>
                    ) : (
                      <>
                        Don’t miss this incredible opportunity to get your health questions answered by one of the best
                        nutritionists in the world.
                      </>
                    )}
                  </p>
                </Col>
              </Row>
            </Container>
          </Section>

          <Section id="course-includes-9" color="light-gray">
            <Container>
              <Row>
                <Col>
                  <h2 className="section-heading text-center mb-0">Over {bonusValue} in bonus gifts</h2>
                </Col>
              </Row>
              <Row className="justify-content-center text-center">
                <Col lg="10" xl="8">
                  <img
                    className="my-4"
                    src="https://cdn.foodrevolution.org/tt2/bonuscontent_badge-01.png"
                    style={{maxHeight: '350px'}}
                  />
                </Col>
              </Row>
              <Row className="justify-content-center">
                <Col lg="10">
                  <p>
                    Your success means everything to us, so we’re including hundreds of dollars worth extras from our
                    trusted partners to help you even more.
                  </p>
                  {variant === 'ad' ? (
                    <>
                      <p>
                        You’ll learn top tips to outsmart insulin resistance, boost energy, and how to eat for gut
                        health and longevity.
                      </p>
                      <p>
                        Get a huge range of diabetes-busting tools, recipes, resources, ebooks, and more for total body
                        wellness. These high-value bonuses alone make it worth it to join <i>Tackling Type 2.</i>
                      </p>
                    </>
                  ) : (
                    <>
                      <p>
                        Discover top tips to outsmart insulin resistance, boost energy, and how to eat for gut health
                        and longevity.
                      </p>
                      <p>
                        You’ll get a huge range of diabetes-busting tools, recipes, resources, ebooks, and more for
                        total body wellness. These high-value bonuses alone make it worth it to join{' '}
                        <i>Tackling Type 2.</i>
                      </p>
                    </>
                  )}
                </Col>
              </Row>
            </Container>
          </Section>
        </div>

        <div id="course-modules">
          <Section id="course-modules-1" color="green" className="text-center text-white">
            <Container>
              <Row>
                <Col>
                  <h2 className="section-only-heading text-uppercase">The Course Modules</h2>
                </Col>
              </Row>
            </Container>
          </Section>

          <Section id="course-modules-2" color="white">
            <Container>
              <Row>
                <Col>
                  {variant === 'ad' ? (
                    <ModuleAccordionV1 modulelist={modulesAd} />
                  ) : (
                    <ModuleAccordionV1
                      modulelist={{prevent: modulesPrevent, optimize: modulesOptimize, reverse: modulesReverse}[bucket]}
                    />
                  )}
                </Col>
              </Row>
            </Container>
          </Section>
        </div>

        <div id="course-bonuses">
          <Section id="course-bonus-list" color="light-gray">
            <Container>
              <Row>
                <Col>
                  <h2 className="section-heading text-center">Join today to get over {bonusValue} in free gifts</h2>
                  <BonusOpen borderColor="medium-gray-50" />
                </Col>
              </Row>
            </Container>
          </Section>

          {version === 'screening' ? (
            <Section id="course-bonus-ac" color="white" className="text-center">
              <Container>
                <Row>
                  <Col>
                    <h4 className="section-heading">PLUS An Exclusive Bonus Just For Masterclass Attendees:</h4>
                    <h2 className="mt-0">The Action Collection</h2>
                  </Col>
                </Row>
                <Row className="align-items-stretch">
                  {acSpeakers.map((speaker, i) => (
                    <div className="d-flex flex-column ac-item-wrap text-center">
                      <div className="ac-item-image-wrap mb-3">
                        <img className="rounded" src={speaker.image} />
                      </div>
                      <div className="ac-item-name balance-text text-800 text-16 mb-1">{speaker.name}</div>
                      <div className="ac-item-title balance-text text-small my-auto">{speaker.title}</div>
                    </div>
                  ))}
                </Row>
                <Row>
                  <Col>
                    <h5 className="mt-4">
                      <i>Join Tackling Type 2 from this screening page to lock in a special bonus.</i>
                    </h5>
                    <p>
                      Get 10 of Food Revolution Network’s most action-oriented interviews with health revolutionaries
                      who are sharing how to use food to feel better than ever. Learn from leading health experts so you
                      can protect yourself and your family as you deep dive into today’s most critical health topics.
                    </p>
                    <p>
                      From nutrition essentials to pesticides to avoid to lasting weight loss, you’ll get a grand tour
                      of the must-haves for long-lasting health and happiness. Each session comes with an action
                      checklist so you can focus on the most important steps and make progress you can feel.
                    </p>
                  </Col>
                </Row>
              </Container>
            </Section>
          ) : null}
        </div>

        <div id="course-instructor">
          <SectionImage
            id="course-brenda"
            color="black"
            imgUrl={require('static/speaker/brenda-headshot.jpg')}
            imgPosition="left"
            className="text-white"
          >
            <h3 className="section-heading">
              About <span className="text-nowrap">Brenda Davis, RD,</span> Your Guide…
            </h3>
            <p>
              Brenda Davis, RD, is an award-winning registered dietitian, one of the world’s most beloved plant-based
              eating advocates, and an internationally acclaimed speaker. She has authored/co-authored 12 books with
              nearly a million copies in print in 15 languages, including <i>Kick Diabetes Essentials</i> and{' '}
              <i>The Kick Diabetes Cookbook.</i> Brenda has been a featured speaker at medical, nutrition, and dietetic
              conferences in over 20 countries on 5 continents. Her personal and professional life goals are one and the
              same: to make this world a more sustainable, more health-supportive, and kinder place.
            </p>
          </SectionImage>

          <Section id="" color="white">
            <Container>
              <Row>
                <Col>
                  <h4 className="section-heading text-center mb-5">
                    Here’s What You’ll Get Today with Tackling Type 2:
                  </h4>
                  <div className="d-flex justify-content-center">
                    <IconList className="text-left m-0">
                      <IconListItem>6 modules, each with 6 easy video lessons</IconListItem>
                      <IconListItem>36 healthy plant-based recipes</IconListItem>
                      <IconListItem>
                        Health Coaches and Certified Nutritionists <br className="d-none d-sm-block" />
                        to answer your questions
                      </IconListItem>
                      <IconListItem>Access to an exclusive community forum</IconListItem>
                      <IconListItem>6 recipe demonstration lessons </IconListItem>
                      <IconListItem>Downloadable Coursebook</IconListItem>
                      <IconListItem>Q&A with Brenda Davis, RD</IconListItem>
                      <IconListItem>Over {bonusValue} in bonus gifts</IconListItem>
                    </IconList>
                  </div>
                </Col>
              </Row>
            </Container>
          </Section>
        </div>

        <div id="course-enroll">
          <SalesCtaSection id="course-cta-2" />

          <Section id="course-guarantee" color="light-gray">
            <Container>
              <Row>
                <Col>
                  <GuaranteeBox title={<>You’re Protected By Our 60-Day, Unconditional, Money-Back Guarantee.</>}>
                    <p>
                      <b>Try it out.</b> If you aren't completely blown away by the course, even if you just don’t like
                      it, just email us at{' '}
                      <a href="mailto:support@foodrevolution.org" target="_blank">
                        support@foodrevolution.org
                      </a>
                      , any time within 60 days after purchase, for a prompt and courteous refund.
                    </p>
                    <p>
                      This means you can even take the whole course, take every lesson, and make every single
                      mouth-watering recipe, and if it doesn’t rock your world, you get every penny back.
                    </p>
                    <p>
                      That’s how confident we are that you’ll LOVE <i>Tackling Type 2.</i>
                    </p>
                    <p>
                      PLUS, if for any reason you request a refund, everything that you’ve downloaded, and everything
                      you’ve learned, is still yours to keep.
                    </p>
                    <p>That’s why we call our guarantee “better than money back.”</p>
                  </GuaranteeBox>
                </Col>
              </Row>
            </Container>
          </Section>
        </div>

        <div id="course-faq">
          <Section id="course-faq-list" color="white">
            <Container>
              <Row>
                <Col>
                  <h2 className="section-heading">Frequently Asked Questions</h2>
                  {variant === 'ad' ? <FaqList faqlist={faqAd} /> : <FaqList slice={version === 'sales' ? 1 : 0} />}
                </Col>
              </Row>
            </Container>
          </Section>
        </div>
      </div>

      <SectionImage
        id="course-action"
        color="light-gray"
        imgPosition="left"
        imgUrl={require('static/backgrounds/1284690585.jpg')}
      >
        <h2 className="section-heading">The best time to take action is today.</h2>
        {variant === 'ad' ? (
          <>
            <h3 className="mt-0">Don’t wait for “someday” when there’s more time. That day may never come.</h3>

            <p>
              <b>This is a crossroads.</b>
            </p>
            <p>
              <b>
                <i>Tackling Type 2</i> is a chance to go in the smart direction.
              </b>
            </p>
            <p>
              It’s the difference between going on autopilot…to making educated decisions{' '}
              <br className="d-none d-xl-block" />
              effortlessly — and getting all the support needed to make healthy habits second nature.
            </p>
          </>
        ) : (
          <>
            <h3 className="mt-0">Don’t wait for “someday” when you have more time.</h3>
            <p>We don’t want you to look back in a year or two and wish you’d taken action sooner.</p>
            <p>
              <b>Today, you are at a crossroads.</b>
            </p>
            <p>
              One path leads to <b>energy, vitality, and eating delicious healthy foods</b> that do not harm…
            </p>
            <p>
              Foods that are <b>powerful enough to heal</b> with every bite.
            </p>
            <p>
              The other can lead to pain, medical complications, insurance hassles, and{' '}
              <br className="d-none d-xl-block" />
              worsening disease. The farther you go down this path, the harder it is to make a change.
            </p>
          </>
        )}
      </SectionImage>

      <SectionImage
        id="course-rise"
        color="white"
        imgPosition="right"
        imgUrl={require('static/backgrounds/1303646379.jpg')}
      >
        {variant === 'ad' ? (
          <>
            <h4 className="mt-4">It’s time to rise up and change the script.</h4>
            <p>
              This is why <i>Tackling Type 2</i> exists.
            </p>
            <p>We hope you’ll join us.</p>
            <p>We’re here to help every single step of the way.</p>
          </>
        ) : (
          <>
            <h4 className="mt-4">
              <i>Tackling Type 2</i> is a chance to go in the right direction.
            </h4>
            <p>
              To make great decisions because you know better — and to give <br className="d-none d-xl-block" />
              yourself all the support you need to make it happen.
            </p>
            <p>It’s about helping you where it matters most: Your health.</p>
            <p>
              You <i>can</i> do this!
            </p>
            <p>
              Join us in <i>Tackling Type 2</i> today.
            </p>
          </>
        )}
      </SectionImage>

      <SalesCtaSection id="course-cta-3" lastSection />
    </>
  );
}
